import { LandingPageLayout } from 'designSystem/layouts/LandingPageLayout'
import { useAdvancedSearchUX } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import React from 'react'

import { CantileverLandingLogo } from './CantileverLandingLogo'
import { LandingRecentsAndFavorites } from './LandingRecentsAndFavorites'
import { LandingSearchBar } from './LandingSearchBar'

export const UnifiedSearchLanding: React.FC = () => {
  const { searchState } = useAdvancedSearchUX()
  const isChatOnly = searchState.chatOnly === true

  return (
    <LandingPageLayout
      hero={<CantileverLandingLogo />}
      search={<LandingSearchBar />}>
      {!isChatOnly ? <LandingRecentsAndFavorites /> : null}
    </LandingPageLayout>
  )
}
